module.exports = __webpack_public_path__ + "img/experts-consultants.397cf134.png";